import windowInit from "./windowInit";
import pingToUpdate from "./pingToUpdate";
import biometricLogin from "./biometricLogin";
import osAdapter from "./osAdapter";

// main function for app.js init file
export function webViewAppInit() {
  if (!osAdapter.inWebView()) {
    return null;
  }

  // OS adapter object
  window.osAdapter = osAdapter;

  // needed for web view
  window.VueApp = window.App;

  // init
  windowInit();
  biometricLogin();

  // useless for ecr25+ app
  if (!osAdapter.isEcrApp()) {
    pingToUpdate();
  }
}
